'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, '__esModule', {
  value: true
});
var TaskMerger = {
  hasNewInfo: function hasNewInfo(task, tasksWithTopic) {
    var haveBlock = false;
    var isWantBlock = false;

    var _iterator = _createForOfIteratorHelper(tasksWithTopic),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var existing = _step.value;

        if (existing.data.haveBlock) {
          haveBlock = true;
        }

        if (existing.data.isWantBlock) {
          isWantBlock = true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (!isWantBlock && task.data.isWantBlock) {
      return true;
    }

    if (!haveBlock && task.data.haveBlock) {
      return true;
    }

    return false;
  },
  merge: function merge(newTask, existingTask) {
    var taskData = newTask.data;
    var existingData = existingTask.data;

    if (!existingData.haveBlock && taskData.haveBlock) {
      existingData.haveBlock = taskData.haveBlock;
      existingData.blockSize = taskData.blockSize;
    }

    if (!existingData.isWantBlock && taskData.isWantBlock) {
      existingData.isWantBlock = true;

      if (!existingData.haveBlock || taskData.haveBlock) {
        existingData.haveBlock = taskData.haveBlock;
        existingTask.size = newTask.size;
      }
    }

    if (existingData.isWantBlock && existingData.haveBlock) {
      existingTask.size = existingData.blockSize;
    }
  }
};
exports.TaskMerger = TaskMerger;